import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faUserSecret,
  faChevronLeft,
  faChevronRight,
  faTimes,
  faCalendarAlt,
  faPortrait,
  faExclamationCircle,
  faCaretDown,
  faUserAlt,
  faCheckCircle,
  faTimesCircle,
  faMinusCircle,
  faClock,
  faTrash,
  faPenSquare,
  faPlus,
  faSave,
  faUsers,
  faBan,
  faCheck
} from "@fortawesome/free-solid-svg-icons";
import { faWindowClose, faIdCard } from "@fortawesome/free-regular-svg-icons";
import { faWhatsappSquare } from "@fortawesome/free-brands-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(
  faUserSecret,
  faChevronLeft,
  faChevronRight,
  faWindowClose,
  faTimes,
  faCalendarAlt,
  faPortrait,
  faIdCard,
  faClock,
  faExclamationCircle,
  faCaretDown,
  faUserAlt,
  faWhatsappSquare,
  faCheckCircle,
  faTimesCircle,
  faMinusCircle,
  faTrash,
  faPenSquare,
  faPlus,
  faSave,
  faUsers,
  faBan,
  faCheck
);

export default FontAwesomeIcon;
